import { FunctionalComponent} from 'preact';
import { useEffect, useState } from 'preact/hooks';
import { Suspense, lazy } from 'preact/compat';
import { useDispatch, useSelector } from 'react-redux';

import styles from './styles.module.scss';

import whaleIcon from './whale.svg';
import {
  selectBanner,
  fetchBanners,
  clickedAd,
  disabledBanner,
  createSelectShouldFetch
} from './slice';

const Settings = lazy(() => import('./Settings'));

const selectShouldFetch = createSelectShouldFetch(Date.now());

const Banner: FunctionalComponent = () => {
  const [state, setState] = useState<'settings'>(null);
  const dispatch = useDispatch();
  const banner = useSelector(selectBanner);

  const shouldFetch = useSelector(selectShouldFetch);

  const toggleSettings = () => {
    setState((prev) => prev ? null : 'settings');
  };

  useEffect(() => {
    if (shouldFetch) {
      dispatch(fetchBanners());
    }
  }, []);

  if (!banner) return null;

  const handleClick = () => {
    dispatch(clickedAd());
  }

  const handleDisable = (value) => {
    setState(null);
    if (value) {
      dispatch(disabledBanner(value));
    }
  }

  return (
    <>
      <section className={styles.container}>
        <img src={banner.impurl} className={styles.impressionImg} alt="" />

        <a href={banner.rurl} onClick={handleClick}>
          <img
            className={styles.banner}
            // src={bannerPic}
            src={banner.burl}
            alt="banner"
          />
        </a>

        <div className={styles.navigation} id="bannerNavigation">
          <div className={styles.popoverContainer}>
            <span className={styles.label}>Ads for the Ocean <img src={whaleIcon} alt='whale' /></span>

            <div className={styles.popover}>
              These advertisements help fund ocean cleanup. If you want to remove them, open the settings on the right.
            </div>
          </div>

          <button className={styles.label} onClick={toggleSettings}>Settings</button>

          {state === 'settings' && (
            <Suspense fallback={null}>
              <Settings onClose={toggleSettings} onDisable={handleDisable} />
            </Suspense>
          )}
        </div>
      </section>
    </>
  );
};

export default Banner;
